import { useEffect } from "react";
import { useLocation } from "react-router";
import { trackPageView } from "@/lib/analytics";

const pageNameMap: Record<string, string> = {
  "/": "Home",
  "/premium": "AI Tools",
  "/employers": "Employers",
  "/jobs": "Job Search",
  "/dashboard": "Candidate Dashboard",
  "/profile": "Profile",
  "/employer/dashboard": "Employer Dashboard",
  "/employer/candidates": "Candidate Search",
};

export const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const pageLabel = pageNameMap[location.pathname] || document.title || "Unknown Page";
    trackPageView(pageLabel, { path: location.pathname });
  }, [location.pathname]);

  return null;
};

export default AnalyticsTracker;
